import React, { useEffect, useState, useRef } from 'react';
import './castingCall.css';
import {
  TextField,
  InputLabel,
  FormControl,
  MenuItem,
  Select,
  Radio,
  RadioGroup,
  FormControlLabel,
  Checkbox,
  Typography,
} from '@mui/material';
import RoleAddModal from './RoleAddModal';
import RoleEditModal from './RoleEditModal';
import { addCastingCall } from '../../api/axios';
import { useNavigate } from 'react-router-dom';
import Alert from '../common/Alert';

// const CrewSelectItems = [
//   "1st Assistant Director",
//   "2nd Assistant Director",
//   "Art Director",
//   "Best Boy",
//   "Boom Operator",
//   "Camera Assistant",
//   "Camera Operator",
//   "Caterer",
//   "Cinematographer",
//   "Costume Coordinator",
//   "Costume Designer",
//   "COVID Compliance Officer",
//   "Crafts and Services",
//   "Director of Photography",
//   "Dolly Grip",
//   "Driver",
//   "Electrician",
//   "Film Editor",
//   "Gaffer",
//   "Generator Operator",
//   "Grip",
//   "Hair Stylist",
//   "Intimacy Coordinator",
//   "Key PA",
//   "Lead Man",
//   "Line Producer",
//   "Location Scout",
//   "Makeup Artist",
//   "Officer PA",
//   "On Set Editor",
//   "Production Accountant",
//   "Production Assistance",
//   "Production Designer",
//   "Prop Master",
//   "Prosthetics Designer",
//   "Screenwriter",
//   "Script Supervisor",
//   "Set Decorator",
//   "Set Dresser",
//   "Set Medic",
//   "Set PA",
//   "SFX Coordinator",
//   "SFX Editor",
//   "SFX Makeup Artist",
//   "SFX Supervisor",
//   "Shopper",
//   "Sound Mixer",
//   "Stunt Choreographer",
//   "Stunt Performer",
//   "Tailor",
//   "Transportation Coordinator",
//   "Unit Production Manager",
//   "Video Assist Operator",
//   "Weapons Wrangler",
//   "Intimacy coordinator",
// ];

const CrewSelectItems = [
  'Acting',
  'Commercials',
  'Content Creator',
  'Crew',
  'Dancing',
  'Modeling',
  'Reality TV',
  'TV Shows',
  'Voiceover',
];

const CastingCallCreate = () => {
  const detailRef = useRef(null);
  const dateRef = useRef(null);
  const paymentRef = useRef(null);
  const companyRef = useRef(null);
  const roleRef = useRef(null);
  const navigate = useNavigate();

  const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];

  const days = Array.from({ length: 31 }, (_, i) => i + 1);
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 10 }, (_, i) => currentYear + i);

  const initialValue = {
    title: '',
    category: '',
    zip: '',
    description: '',
    area: '',
    check: false,
    unionStatus: '',
    month: '',
    day: '',
    year: '',
    amount: '',
    period: '',
    companyTitle: '',
    companyNumber: '',
    companyUrl: '',
    roles: [],
  };
  const [formData, setFormData] = useState(initialValue);
  const [formError, setFormError] = useState({});
  const [openRoleModal, setOpenRoleModal] = useState(false);
  const [openRoleEditModal, setOpenRoleEditModal] = useState(false);
  const [selectedEditRole, setSelectedEditRole] = useState(null);
  const [editingRoleIndex, setEditingRoleIndex] = useState(null);
  const [loading, setLoading] = useState(false);

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [alertSeverity, setAlertSeverity] = useState('success');
  const [alertMessage, setAlertMessage] = useState('');

  const currentDate = new Date();
  const requiresRole = !!formData.category && formData.category.toLowerCase() !== 'crew';

  //auto scroll to page top
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  //save changed inputs
  const handleInputChange = (name, value) => {
    setFormError({
      ...formError,
      [name]: '',
    });

    setFormData((prevData) => {
      const nextData = { ...prevData, [name]: value };

      if (name === 'category' && value && value.toLowerCase() === 'crew') {
        nextData.roles = [];
      }

      return nextData;
    });
  };

  //auto scroll for ref
  const scrollToRef = (ref) => {
    if (ref) {
      const navbarHeight = 105;
      const topPosition =
        ref.getBoundingClientRect().top + window.scrollY - navbarHeight;
      window.scrollTo({ top: topPosition, behavior: 'smooth' });
    }
  };

  //role add modal open
  const handleClickAddRole = () => {
    setOpenRoleModal(true);
  };

  //added role save in form data
  const handleAddRole = (role) => {
    setFormData((prevData) => ({
      ...prevData,
      roles: [...prevData.roles, role],
    }));
  };

  //added role remove from form data
  const handleDeleteRole = (indexToDelete) => {
    setFormData((prevData) => ({
      ...prevData,
      roles: prevData.roles.filter((_, index) => index !== indexToDelete),
    }));
  };

  const handleClickEditRole = (role, index) => {
    setSelectedEditRole(role);
    setEditingRoleIndex(index);
    setOpenRoleEditModal(true);
  };

  const handleEditRole = (updatedRole) => {
    setFormData((prevData) => {
      const updatedRoles = [...prevData.roles];
      updatedRoles[editingRoleIndex] = updatedRole;
      return {
        ...prevData,
        roles: updatedRoles,
      };
    });
    setSelectedEditRole(null);
    setEditingRoleIndex(null);
  };

  //validate form
  const validateForm = () => {
    const errors = {};

    if (!formData.title) {
      errors.title = 'Please add casting call title';
    }
    if (!formData.category) {
      errors.category = 'Please select a category';
    }
    if (!formData.zip) {
      errors.zip = 'Please add Zip/ Postal code';
    }
    if (!formData.description) {
      errors.description = 'Please add small description';
    }
    if (!formData.area) {
      errors.area = 'Please select an area';
    }
    if (!formData.month) {
      errors.month = 'Please select a month';
    }
    if (!formData.day) {
      errors.day = 'Please select a day';
    }
    if (!formData.year) {
      errors.year = 'Please select a year';
    }
    if (!formData.unionStatus) {
      errors.unionStatus = 'Please select a Union status';
    }
    if (formData.month && formData.day && formData.year) {
      const selectedDate = new Date(
        `${formData.year}-${formData.month}-${formData.day}`
      );
      if (selectedDate < currentDate) {
        errors.date = 'Expiration date should be  no earlier than tommorow ';
      }
    }
    if (formData.amount && formData.amount <= 0) {
      errors.amount = 'Amount should be greater than 0';
    }
    if (formData.amount && !formData.period) {
      errors.period = 'Please select a period for amount';
    }
    if (requiresRole && formData.roles.length === 0) {
      errors.roles = 'Please add at least one role';
    }

    setFormError(errors);
    return Object.keys(errors).length === 0;
  };

  //casting call create
  const handleClickAddCastingCall = async () => {
    if (validateForm()) {
      setLoading(true);

      const body = {
        title: formData.title,
        category: formData.category,
        zipCode: formData.zip,
        shortDesc: formData.description,
        auditionType: formData.check,
        unionStatus: formData.unionStatus, // Add union status to payload
        expirationDate: `${formData.month}/${formData.day}/${formData.year}`,
        companyName: formData.companyTitle,
        contactNo: formData.companyNumber,
        websiteURL: formData.companyUrl,
        area: formData.area,
        amount: formData.amount,
        period: formData.period,
        newRoles: formData.roles,
      };

      try {
        const res = await addCastingCall(body);
        if (res.success) {
          setFormData(initialValue);
          setAlertSeverity('success');
          setAlertMessage('Casting call add successfull!');
          setTimeout(() => {
            navigate('/castingcalls');
          }, 1000);
        }
      } catch (error) {
        // console.log('Casting call add faild!', error);
        setAlertSeverity('error');
        setAlertMessage('Casting call add faild!');
      } finally {
        setOpenSnackbar(true);
        setLoading(false);
      }
    }
  };

  // Add this reusable style object at the component level
const inputWithValueStyle = {
  // '& .MuiInputBase-input': {
  //   color: (theme) => theme.palette.text.primary, 
  // },
  // '& .Mui-focused .MuiInputBase-input, & .MuiInputBase-input:not(:placeholder-shown)': {
  //   color: '#e54447',
  // },
  // '& .MuiSelect-select:not([aria-labelledby$="-placeholder"])': {
  //   color: '#e54447', 
  // }
  
};

  return (
    <div className='castingCall-view-full-wrapper pb-20'>
      <div className='castingCall-view-container '>
        <div className='castingCall-view-grid '>
          <div className='castingCall-view-details'>
            <span className='all-role-count'>Post a new casting call</span>
            <span className='castingCall-create-section-topic' ref={detailRef}>
              Details
            </span>
            <TextField
              label='Casting call title'
              name='title'
              value={formData.title}
              onChange={(e) => handleInputChange('title', e.target.value)}
              variant='filled'
              fullWidth
              required
              inputProps={{ style: { textTransform: 'uppercase' } }}
              sx={{
                backgroundColor: 'transparent',
                '& .MuiFilledInput-root': {
                  backgroundColor: 'transparent',
                },
                ...inputWithValueStyle,
              }}
              error={!!formError.title}
              helperText={formError.title}
            />
            <div className='grid-inputs'>
              <FormControl
                fullWidth
                variant='filled'
                sx={{
                  backgroundColor: 'transparent',
                  '& .MuiFilledInput-root': {
                    backgroundColor: 'transparent',
                  },
                  ...inputWithValueStyle,
                }}
              >
                <InputLabel>Categories</InputLabel>
                <Select
                  value={formData.category}
                  onChange={(e) =>
                    handleInputChange('category', e.target.value)
                  }
                  name='category'
                  MenuProps={{
                    disableScrollLock: true,
                  }}
                >
                  {CrewSelectItems.map((op) => (
                    <MenuItem value={op}>{op}</MenuItem>
                  ))}
                  {/* <MenuItem value="acting">Acting</MenuItem>
                  <MenuItem value="modeling">Modeling</MenuItem>
                  <MenuItem value="pageant">Pageant</MenuItem>
                  <MenuItem value="tvShows">TV Shows</MenuItem>
                  <MenuItem value="theater">Theater</MenuItem>
                  <MenuItem value="voice&Movies">
                    Voice over 
                  </MenuItem>
                  <MenuItem value="voice&Movies">
                    Movies
                  </MenuItem> */}
                </Select>
                {formError.category && (
                  <Typography
                    variant='caption'
                    color='error'
                    sx={{ ml: '15px' }}
                  >
                    {formError.category}
                  </Typography>
                )}
              </FormControl>
              <FormControl
              fullWidth
              variant='filled'
              sx={{
                backgroundColor: 'transparent',
                '& .MuiFilledInput-root': {
                  backgroundColor: 'transparent',
                },
                ...inputWithValueStyle,
                // marginTop: '15px'
              }}
            >
              <InputLabel>Union Status</InputLabel>
              <Select
                value={formData.unionStatus}
                onChange={(e) => handleInputChange('unionStatus', e.target.value)}
                name='unionStatus'
                MenuProps={{
                  disableScrollLock: true,
                }}
              >
                <MenuItem value="Union">Union</MenuItem>
                <MenuItem value="Non-Union">Non-Union</MenuItem>
              </Select>
              {formError.unionStatus && (
                <Typography
                  variant='caption'
                  color='error'
                  sx={{ ml: '15px' }}
                >
                  {formError.unionStatus}
                </Typography>
              )}
            </FormControl>
              <TextField
                label='Zip/ Postal code'
                name='zip'
                value={formData.zip}
                onChange={(e) => handleInputChange('zip', e.target.value)}
                variant='filled'
                fullWidth
                sx={{
                  backgroundColor: 'transparent',
                  '& .MuiFilledInput-root': {
                    backgroundColor: 'transparent',
                  },
                  ...inputWithValueStyle,
                }}
                error={!!formError.zip}
                helperText={formError.zip}
              />
            </div>
            <FormControl>
  <RadioGroup
    row
    name='area'
    value={formData.area}
    onChange={(e) => handleInputChange('area', e.target.value)}
  >
    <FormControlLabel
      value='local'
      control={<Radio checked={formData.area === 'local'} />}
      label='Local'
      sx={{ color: formData.area === 'local' ? '#e54447' : 'gray' }}
    />
    <FormControlLabel
      value='nation'
      control={<Radio checked={formData.area === 'nation'} />}
      label='Nationwide'
      sx={{ color: formData.area === 'nation' ? '#e54447' : 'gray' }}
    />
    <FormControlLabel
      value='world'
      control={<Radio checked={formData.area === 'world'} />}
      label='Worldwide'
      sx={{ color: formData.area === 'world' ? '#e54447' : 'gray' }}
    />
  </RadioGroup>
  {formError.area && (
    <Typography variant='caption' color='error' sx={{ ml: '15px' }}>
      {formError.area}
    </Typography>
  )}
</FormControl>
            <TextField
              label='Write a short description'
              name='description'
              value={formData.description}
              onChange={(e) => handleInputChange('description', e.target.value)}
              variant='filled'
              fullWidth
              required
              inputProps={{ maxLength: 1000 }}
              sx={{
                backgroundColor: 'transparent',
                '& .MuiFilledInput-root': {
                  backgroundColor: 'transparent',
                },
                ...inputWithValueStyle,
              }}
              error={!!formError.description}
              helperText={formError.description}
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={formData.check}
                  onChange={(e) => handleInputChange('check', e.target.checked)}
                  inputProps={{ 'aria-label': 'controlled' }}
                />
              }
              label='Online audition (Online auditions means your auditions will take place remotely)'
              sx={{ color:'gray'}}
            />
            <span className='castingCall-create-section-topic' ref={dateRef}>
              Expiration date
            </span>
            <div className='castingCall-dropdown-list'>
              <FormControl
                fullWidth
                variant='filled'
                sx={{
                  backgroundColor: 'transparent',
                  '& .MuiFilledInput-root': {
                    backgroundColor: 'transparent',
                  },
                  ...inputWithValueStyle,
                }}
              >
                <InputLabel>Month</InputLabel>
                <Select
                  value={formData.month}
                  onChange={(e) => handleInputChange('month', e.target.value)}
                  name='month'
                  MenuProps={{
                    disableScrollLock: true,
                  }}
                >
                  {months.map((month, index) => (
                    <MenuItem key={index} value={index + 1}>
                      {month}
                    </MenuItem>
                  ))}
                </Select>
                {formError.month && (
                  <Typography
                    variant='caption'
                    color='error'
                    sx={{ ml: '15px' }}
                  >
                    {formError.month}
                  </Typography>
                )}
              </FormControl>
              <FormControl
                fullWidth
                variant='filled'
                sx={{
                  backgroundColor: 'transparent',
                  '& .MuiFilledInput-root': {
                    backgroundColor: 'transparent',
                  },
                  ...inputWithValueStyle,
                }}
              >
                <InputLabel>Day</InputLabel>
                <Select
                  value={formData.day}
                  onChange={(e) => handleInputChange('day', e.target.value)}
                  name='day'
                  MenuProps={{
                    disableScrollLock: true,
                  }}
                >
                  {days.map((day) => (
                    <MenuItem key={day} value={day}>
                      {day}
                    </MenuItem>
                  ))}
                </Select>
                {formError.day && (
                  <Typography
                    variant='caption'
                    color='error'
                    sx={{ ml: '15px' }}
                  >
                    {formError.day}
                  </Typography>
                )}
              </FormControl>
              <FormControl
                fullWidth
                variant='filled'
                sx={{
                  backgroundColor: 'transparent',
                  '& .MuiFilledInput-root': {
                    backgroundColor: 'transparent',
                  },
                  ...inputWithValueStyle,
                }}
              >
                <InputLabel>Year</InputLabel>
                <Select
                  value={formData.year}
                  onChange={(e) => handleInputChange('year', e.target.value)}
                  name='year'
                  MenuProps={{
                    disableScrollLock: true,
                  }}
                >
                  {years.map((year) => (
                    <MenuItem key={year} value={year}>
                      {year}
                    </MenuItem>
                  ))}
                </Select>
                {formError.year && (
                  <Typography
                    variant='caption'
                    color='error'
                    sx={{ ml: '15px' }}
                  >
                    {formError.year}
                  </Typography>
                )}
              </FormControl>
            </div>
            {formError.date && (
              <Typography variant='caption' color='error' sx={{ ml: '15px' }}>
                {formError.date}
              </Typography>
            )}
            <span className='castingCall-create-section-topic' ref={paymentRef}>
              Payment
            </span>
            <div className='castingCall-dropdown-list'>
              <TextField
                label='Amount $'
                name='amount'
                type='number'
                value={formData.amount}
                onChange={(e) => handleInputChange('amount', e.target.value)}
                variant='filled'
                fullWidth
                sx={{
                  backgroundColor: 'transparent',
                  '& .MuiFilledInput-root': {
                    backgroundColor: 'transparent',
                  },
                  '& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button':
                    {
                      display: 'none',
                    },
                    ...inputWithValueStyle,
                }}
                onKeyDown={(e) => {
                  if (e.key === '-' || e.key === 'e' || e.key === 'E') {
                    e.preventDefault();
                  }
                }}
                error={!!formError.amount}
                helperText={formError.amount}
              />
              <FormControl
                fullWidth
                variant='filled'
                sx={{
                  backgroundColor: 'transparent',
                  '& .MuiFilledInput-root': {
                    backgroundColor: 'transparent',
                  },
                  ...inputWithValueStyle,
                }}
              >
                <InputLabel>Period</InputLabel>
                <Select
                  value={formData.period}
                  onChange={(e) => handleInputChange('period', e.target.value)}
                  name='period'
                  MenuProps={{
                    disableScrollLock: true,
                  }}
                >
                  <MenuItem value='hour'>Hour</MenuItem>
                  <MenuItem value='day'>Day</MenuItem>
                  <MenuItem value='week'>Week</MenuItem>
                  <MenuItem value='month'>Month</MenuItem>
                  <MenuItem value='project'>Project</MenuItem>
                  <MenuItem value='tfp'>TFP</MenuItem>
                </Select>
                {formError.period && (
                  <Typography
                    variant='caption'
                    color='error'
                    sx={{ ml: '15px' }}
                  >
                    {formError.period}
                  </Typography>
                )}
              </FormControl>
            </div>
            <span className='castingCall-create-section-topic' ref={companyRef}>
              Company info
            </span>
            <TextField
              label='Company title'
              name='companyTitle'
              value={formData.companyTitle}
              onChange={(e) =>
                handleInputChange('companyTitle', e.target.value)
              }
              variant='filled'
              fullWidth
              sx={{
                backgroundColor: 'transparent',
                '& .MuiFilledInput-root': {
                  backgroundColor: 'transparent',
                },
                ...inputWithValueStyle,
              }}
            />
            <div className='grid-inputs'>
              <TextField
                label='Company number'
                name='companyNumber'
                value={formData.companyNumber}
                onChange={(e) =>
                  handleInputChange('companyNumber', e.target.value)
                }
                variant='filled'
                fullWidth
                sx={{
                  backgroundColor: 'transparent',
                  '& .MuiFilledInput-root': {
                    backgroundColor: 'transparent',
                  },
                  ...inputWithValueStyle,
                }}
              />
              <TextField
                label='Company website'
                name='companyUrl'
                value={formData.companyUrl}
                onChange={(e) =>
                  handleInputChange('companyUrl', e.target.value)
                }
                variant='filled'
                fullWidth
                sx={{
                  backgroundColor: 'transparent',
                  '& .MuiFilledInput-root': {
                    backgroundColor: 'transparent',
                  },
                  ...inputWithValueStyle,
                }}
              />
            </div>
            {requiresRole ? (
              <>
                <div className='castingCall-create-role'>
                  <span className='all-role-count' ref={roleRef}>
                    {formData.roles.length} Roles
                  </span>
                  <button className='homeMiddle2' onClick={handleClickAddRole}>
                    {formData.roles.length === 0
                      ? 'ADD A ROLE'
                      : 'ADD ANOTHER ROLE'}
                  </button>
                </div>
                <div className='created-role-list'>
                  {formData.roles?.map((role, index) => (
                    <div className='created-role-card' key={index}>
                      <span>{role.title}</span>
                      <span>{role.desc}</span>
                      <span className='text-capitalize'>{role.gender}</span>
                      <span>
                        {role.ageMin} - {role.ageMax}
                      </span>
                      <span className='text-capitalize'>{role.castingRole}</span>
                      <span>{role.auditionType}</span>
                      <span>
                        {role.ethinicity?.map((item, ethIndex) => (
                          <span key={ethIndex}>{item}{ethIndex < role.ethinicity.length - 1 ? ', ' : ''}</span>
                        ))}
                      </span>
                      <div className='created-role-buttons'>
                        <span
                          style={{ color: '#6E0506', cursor: 'pointer' }}
                          onClick={() => handleClickEditRole(role, index)}
                        >
                          Edit Role
                        </span>
                        <span
                          style={{ color: 'red', cursor: 'pointer' }}
                          onClick={() => handleDeleteRole(index)}
                        >
                          Delete Role
                        </span>
                      </div>
                    </div>
                  ))}
                </div>
              </>
            ) : (
              <div className='castingCall-create-role' style={{ marginTop: 12 }}>
                <span className='all-role-count' ref={roleRef}>
                  No role required for Crew casting calls
                </span>
              </div>
            )}
          </div>
          <div className='castingCall-view-ref-container'>
            <div className='castingCall-ref-list'>
              <span
                className='castingCall-add-ref'
                onClick={() => scrollToRef(detailRef.current)}
              >
                Add Details
              </span>
              <span
                className='castingCall-add-ref'
                onClick={() => scrollToRef(dateRef.current)}
              >
                Expiration Date
              </span>
              <span
                className='castingCall-add-ref'
                onClick={() => scrollToRef(paymentRef.current)}
              >
                Add Payment
              </span>
              <span
                className='castingCall-add-ref'
                onClick={() => scrollToRef(companyRef.current)}
              >
                Add Company Info
              </span>
              <span
                className='castingCall-add-ref'
                onClick={() => scrollToRef(roleRef.current)}
              >
                Add Roles
              </span>
            </div>
            <div className='role-add-button'>
              {formError.roles && (
                <Typography variant='caption' color='error'>
                  {formError.roles}
                </Typography>
              )}
            </div>
            <div className='role-add-button'>
              <button
                className='castingCall-view-apply-button'
                onClick={handleClickAddCastingCall}
              >
                {loading ? 'PUBLISHING..' : 'PUBLISH'}
              </button>
            </div>
          </div>
        </div>
        <RoleAddModal
          openRoleModal={openRoleModal}
          setOpenRoleModal={setOpenRoleModal}
          handleAddRole={handleAddRole}
        />
        <RoleEditModal
          openRoleEditModal={openRoleEditModal}
          setOpenRoleEditModal={setOpenRoleEditModal}
          handleEditRole={handleEditRole}
          selectedEditRole={selectedEditRole}
          setSelectedEditRole={setSelectedEditRole}
        />
        <Alert
          openSnackbar={openSnackbar}
          alertSeverity={alertSeverity}
          setOpenSnackbar={setOpenSnackbar}
          alertMessage={alertMessage}
        />
      </div>
    </div>
  );
};

export default CastingCallCreate;
